import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';
import { useMutation, useQueryClient } from 'react-query';
import { removeTravelArrangements } from 'RestAPIs/travel-arrangements';

type RemoveTravelArrangementsProps = {
  employeeId: number;
  empTrvArrangementId: number;
};

const useRemoveTravelArrangements = () => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ employeeId, empTrvArrangementId }: RemoveTravelArrangementsProps) =>
      removeTravelArrangements(employeeId, empTrvArrangementId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('travelArrangements');
        showSuccessSnackbar();
      },
      onError: () => {
        showErrorSnackbar();
      }
    }
  );
};

export default useRemoveTravelArrangements;
